import { Keys, Scene } from "excalibur";
import { goToScene } from "../../main";
import { gameState, inventoryState } from "../../state/stateManager";
import { createGainedItem, sendAlert } from "../../utils";
import { Resources } from "../../Resources";

export default class BoxesMarket extends Scene {
  onActivate() {
    console.log("inside boxesMenu");
    this.boxes = document.getElementById("hive-boxes");
    this.boxes.classList.add("activeMenu");
    this.menu = document.getElementById("buy-boxes-menu");
    this.menu.classList.add("activeMenuMenu");
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      goToScene("onlineMarket");
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Space)) {
      console.log("buy; pressed space");
      let coins = gameState.getCoins();

      if (coins >= 40) {
        console.log("have enough coins, should buy");
        let inventory = inventoryState.getInventory();
        inventory.boxes = inventory.boxes + 1;
        gameState.setCoins(coins - 40);
        Resources.Coins.play();
        createGainedItem("Hive Box");
      } else {
        Resources.Error.play();
        sendAlert("You Do Not Have Enough Coins");
      }
    }
  }
  onDeactivate() {
    this.boxes.classList.remove("activeMenu");
    this.menu.classList.remove("activeMenuMenu");
  }
}
